<template>
	<Transition
		name="slide-in"
		@after-leave="$emit('closed')"
	>
		<div
			v-if="show"
			class="fixed top-[92px] left-1/2 -translate-x-1/2 z-[10000] text-white px-6 py-4 rounded-lg shadow-lg max-w-md w-full mx-4"
			style="background-color: #01b885"
		>
			<div class="flex items-center justify-between gap-4">
				<div class="flex items-center gap-3">
					<svg
						class="h-6 w-6 flex-shrink-0"
						fill="none"
						stroke="currentColor"
						viewBox="0 0 24 24"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M5 13l4 4L19 7"
						></path>
					</svg>
					<div>
						<p class="font-bold">Success!</p>
						<p class="text-sm">{{ message }}</p>
					</div>
				</div>
				<button
					type="button"
					class="flex-shrink-0 hover:opacity-80 rounded p-1 transition-opacity"
					aria-label="Close"
					@click="close"
				>
					<svg
						class="h-5 w-5"
						fill="none"
						stroke="currentColor"
						viewBox="0 0 24 24"
					>
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M6 18L18 6M6 6l12 12"
						></path>
					</svg>
				</button>
			</div>
		</div>
	</Transition>
</template>

<script setup>
const props = defineProps({
	message: {
		type: String,
		default: "You have successfully unsubscribed"
	},
	autoDismiss: {
		type: Number,
		default: 10000 // 10 seconds
	}
});

defineEmits(["closed"]);

const show = ref(false);
let dismissTimer = null;

const close = () => {
	show.value = false;
	if (dismissTimer) {
		clearTimeout(dismissTimer);
		dismissTimer = null;
	}
};

const open = () => {
	show.value = true;

	// Auto-dismiss after specified time
	if (props.autoDismiss > 0) {
		dismissTimer = setTimeout(() => {
			close();
		}, props.autoDismiss);
	}
};

// Expose methods
defineExpose({
	open,
	close
});

onBeforeUnmount(() => {
	if (dismissTimer) {
		clearTimeout(dismissTimer);
	}
});
</script>

<style scoped>
.slide-in-enter-active {
	animation: fade-scale-in 0.3s ease-out;
}

.slide-in-leave-active {
	animation: fade-scale-out 0.2s ease-in;
}

@keyframes fade-scale-in {
	from {
		transform: translateX(-50%) scale(0.9);
		opacity: 0;
	}
	to {
		transform: translateX(-50%) scale(1);
		opacity: 1;
	}
}

@keyframes fade-scale-out {
	from {
		transform: translateX(-50%) scale(1);
		opacity: 1;
	}
	to {
		transform: translateX(-50%) scale(0.9);
		opacity: 0;
	}
}
</style>
